import { SUPPORTED_LOCALES } from '@trip-ux/constants';
import { MouseEvent, FocusEventHandler } from 'react';
export enum DATE_PART {
  YEAR = 'year',
  MONTH = 'month',
  DAY = 'day'
}

export enum ERROR_TYPES {
  INVALID_DATE = 'invalid_date',
  RANGE_ERROR = 'out_of_range',
  DATE_REQUIRED = 'required',
  MAX_AGE_ERROR = 'max_age_error'
}

export interface DateObj {
  year: number;
  month: number;
  date: number;
  isDisabled?: boolean;
}

export interface DatePickerProps {
  id?: string;
  name: string;
  language?: SUPPORTED_LOCALES;
  dateFormat: string;
  defaultValue?: string;
  defaultFocus?: Date;
  disabled: boolean;
  readOnly?: boolean;
  disabledDays?: {
    before?: Date;
    after?: Date;
  };
  onError?: (err?: ERROR_TYPES) => void;
  errors?: string[];
  onChange: (date: string) => void;
  onBlur?: FocusEventHandler;
  onFocus?: FocusEventHandler;
  required: boolean;
  labels: {
    nextMonth?: string;
    prevMonth?: string;
    togglePicker?: string;
    textBoxAriaLabel?: string;
    toggleAriaLabel?: string;
    calendarAriaLabel?: string;
  };
  className?: string;
  showLabel?: boolean;
  tooltipContent?: string;
  value: string;
  isSearch?: boolean;
  children?: React.ReactNode;
}

export interface PickerElementProps {
  day: DateObj;
  isFocused?: boolean;
  isMonthToggle?: boolean;
  isHidden?: boolean;
  lang: SUPPORTED_LOCALES;
  selectDate: (e: MouseEvent, year: number, month: number, date: number) => void;
  selectedDate: DateObj;
}

export interface MonthToggleProps {
  inc: number;
  disabledDays?: {
    before?: Date;
    after?: Date;
  };
  id: string;
  months: string[];
  focusedDate: DateObj;
  shift: (inc: number, unit: DATE_PART, isFirstOfMonth: boolean, monthToggle: boolean) => void;
  lang: SUPPORTED_LOCALES;
  labels: {
    nextMonth?: string;
    prevMonth?: string;
    togglePicker?: string;
    textBoxAriaLabel?: string;
    toggleAriaLabel?: string;
    calendarAriaLabel?: string;
  };
}
